<template>
  <Modal v-model="modal" width="400" class="modal">
    <div style="text-align:center">
      <div class="icon"></div>
      <div class="text">{{text}}</div>
    </div>
    <div slot="footer">
      <Button size="large" @click="modal=false">{{$t('btn.b1')}}</Button>
      <Button class="d" size="large" @click="del">{{$t('btn.b2')}}</Button>
    </div>
  </Modal>
</template>
<script>
/* 删除确认 */
export default {
  data(){
    return {
      modal:false,
      id:null,
      text:''
    }
  },
  methods:{
    del(){
      this.modal=false
      this.$emit('del',this.id)
    }
  }
}
</script>
<style lang="less" scoped>
.icon{
  width: 100px;
  height: 100px;
  background: url(../assets/shanchu.png) no-repeat;
  margin: 20px auto 16px;
}
.text{
  font-size: 16px;
  line-height: 24px;
  color: #000;
}
.modal{
  /deep/ .ivu-modal-footer{
    padding: 0 0 20px;
    text-align: center;
    .ivu-btn{
      border-radius: 0;
      width: 45%;
      font-size: 16px;
      color: #000;
      &.d{
        color: #F5222D
      }
    }
  }
}
</style>
